module.exports = __webpack_public_path__ + "img/top.fb6cb8f1.jpg";